import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M60.2132 60.2132C64.4088 56.0176 67.266 50.6721 68.4236 44.8527C69.5811 39.0333 68.987 33.0013 66.7164 27.5195C64.4458 22.0377 60.6006 17.3524 55.6671 14.0559C50.7336 10.7595 44.9334 9.00001 39 9.00001L39 39L60.2132 60.2132Z",
  fill: "#E0E5FF"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "40",
  cy: "39",
  r: "28",
  transform: "rotate(-180 40 39)",
  stroke: "#4D4E58",
  "stroke-width": "4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M38.9995 22.0002V40.0002L52.4995 53.5002",
  stroke: "#4D4E58",
  "stroke-width": "4",
  "stroke-linecap": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  name: 'Delay',
  props: {
    size: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size || 80,
    height: __props.size || 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_5, 8, _hoisted_1))
}
}

})